(function () {
  'use strict';

  angular
    .module('app.page-maintenances', []);
})();
